import Swal from 'sweetalert2';
import axios from 'axios';


export function downloadFile(File) {
  axios({
    headers: {
      'Authorization': `Bearer ${JSON.parse(localStorage.getItem("currentUser")).token.key}`
    },
    url: 'api/resources/GetFile',
    method: 'POST',       // Worked using POST or PUT. Prefer POST
    responseType: 'blob', // important
    data: { fileName: File }
  }).then((response) => {
    const actualFileName =  response.headers.filename;
    const fileType = 'application/' + (actualFileName.endsWith('.pdf') ? 'pdf' : 'vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    const url = window.URL.createObjectURL(new Blob([response.data], { type: fileType }));
    const link = document.createElement('a');
    link.href = url;
    if (!actualFileName.endsWith('.pdf') || actualFileName.includes('LetterCreateiPSP')) {
      link.download = actualFileName.includes('LetterCreateiPSP') ? actualFileName.substring(17) : actualFileName;
    }
    link.click();
  }).catch((error) => {
    console.log(error);
    Swal.fire(
      'Error ' + error.response?.status,
      error.response?.data,
      'error'
    );
    return;
  });

}